import { requestActions } from '@actions/apiHelpers';
import { Observable, of } from 'rxjs';
import { ReduxAction } from '@app/types';
import { combineEpics, ofType } from 'redux-observable';
import { catchError, map, mergeMap, startWith } from 'rxjs/operators';
import { apiObservable } from '@support/api';
import type { AppState } from '@reducers/rootReducer';

const _publicProfileEpic = requestActions('PUBLIC_PROFILE', ['fetch', 'update', 'delete']);

export const fetchPublicProfile = _publicProfileEpic['fetch'];
export const updatePublicProfile = _publicProfileEpic['update'];
export const deletePublicProfile = _publicProfileEpic['delete'];

export const selectPublicProfile = (state: AppState) => state.data.publicProfile;

const fetchPublicProfileEpic = (action$: Observable<ReduxAction>) =>
  action$.pipe(
    ofType('FETCH_PUBLIC_PROFILE'),
    mergeMap(() =>
      apiObservable('GET', '/profile/', undefined, {
        apiVersion: 'v2',
      }).pipe(
        map(_publicProfileEpic['fetchSucceeded']),
        startWith(_publicProfileEpic['fetchRequested']()),
        catchError((err) => {
          return of(_publicProfileEpic['fetchFailed'](err));
        }),
      ),
    ),
  );

const updatePublicProfileEpic = (action$: Observable<ReduxAction>) =>
  action$.pipe(
    ofType('UPDATE_PUBLIC_PROFILE'),
    mergeMap(({ payload }) =>
      apiObservable(
        'PUT',
        '/profile/',
        {
          slug: payload.slug,
        },
        {
          apiVersion: 'v2',
        },
      ).pipe(
        map(_publicProfileEpic['updateSucceeded']),
        startWith(_publicProfileEpic['updateRequested']()),
        catchError((err) => {
          return of(_publicProfileEpic['updateFailed'](err));
        }),
      ),
    ),
  );

const deletePublicProfileEpic = (action$: Observable<ReduxAction>) =>
  action$.pipe(
    ofType('DELETE_PUBLIC_PROFILE'),
    mergeMap(() =>
      apiObservable('DELETE', '/profile/', undefined, {
        apiVersion: 'v2',
      }).pipe(
        map(_publicProfileEpic['deleteSucceeded']),
        startWith(_publicProfileEpic['deleteRequested']()),
        catchError((err) => {
          return of(_publicProfileEpic['deleteFailed'](err));
        }),
      ),
    ),
  );

export const publicProfileEpic = combineEpics(
  fetchPublicProfileEpic,
  updatePublicProfileEpic,
  deletePublicProfileEpic,
);
